module.exports = __webpack_public_path__ + "img/xm.b7b4dd3e.jpg";